import React from 'react';
import { Accordion } from 'react-bootstrap';
import CollapsibleItem from './CollapsibleItem';

interface ICollapsible {
  className?: string;
  children?: React.ReactNode;
  leftHeaderContent: React.ReactNode;
  eventKey: string;
  defaultOpen?: boolean;
}

const Collapsible = (props: ICollapsible) => {
  return (
    <Accordion
      className={props.className}
      defaultActiveKey={props.defaultOpen ? props.eventKey : undefined}
    >
      <CollapsibleItem
        eventKey={props.eventKey}
        leftHeaderContent={props.leftHeaderContent}
      >
        {props.children}
      </CollapsibleItem>
    </Accordion>
  );
};

export default Collapsible;
